import { Route, Routes } from "react-router-dom";

import { BoardPage } from "./pages/BoardPage.js";
import { NotFoundPage } from "./pages/NotFoundPage.js";
import { StageBoardPage } from "./pages/StageBoardPage.js";

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/e/:eventId" element={<BoardPage />} />
      {/* monitor CR-01: per-stage board */}
      <Route path="/s/:stageId" element={<StageBoardPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
